"use client";

import { cn } from "../../lib/utils";
import { motion, MotionProps } from "framer-motion";
import React from "react";

const animationProps = {
  initial: { "--x": "100%", scale: 0.8 },
  animate: { "--x": "-100%", scale: 1 },
  whileTap: { scale: 0.95 },
  transition: {
    repeat: Infinity,
    repeatType: "loop" as const,
    repeatDelay: 1,
    type: "spring" as const,
    stiffness: 20,
    damping: 15,
    mass: 2,
    scale: {
      type: "spring" as const,
      stiffness: 200,
      damping: 5,
      mass: 0.5,
    },
  },
};

interface ShinyButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof MotionProps>,
    MotionProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const ShinyButton = React.forwardRef<
  HTMLButtonElement,
  ShinyButtonProps
>(({ children, className, ...props }, ref) => {
  return (
    <motion.button
      ref={ref}
      className={cn(
        "relative cursor-pointer rounded-lg px-6 py-2 font-[var(--font-weight-medium)] backdrop-blur-xl border transition-shadow duration-300 ease-in-out hover:shadow-lg overflow-hidden",
        className,
      )}
      {...animationProps}
      {...props}
    >
      <span
        className="relative flex items-center gap-2 size-full text-[var(--font-size-sm)] font-[var(--font-weight-medium)] tracking-wide z-20"
      >
        {children}
      </span>
      <span
        style={{
          backgroundImage:
            "linear-gradient(-75deg,transparent calc(var(--x)+20%),rgba(255,255,255,0.8) calc(var(--x)+25%),transparent calc(var(--x)+100%))",
        }}
        className="absolute inset-0 z-10 block rounded-[inherit]"
      />
    </motion.button>
  );
});

ShinyButton.displayName = "ShinyButton";
